Fancybox.bind('[data-fancybox="gallery"]', {
  Toolbar: {
    display: {
      left: ["infobar"],
      middle: [],
      right: [
        "close",
      ],
    }
  },
});